import { EXPLORE_SLUG } from "types/api/explore";

export const newExploreValidFilters = [
  "slug",
  "term",
  "category_id",
  "type",
  "duration",
  "cost",
  "publish_status",
  "instructor_ids",
];

export const exploreTitle = {
  [EXPLORE_SLUG.INSTRUCTOR]: "مدرس",
  [EXPLORE_SLUG.COURSE]: "عنوان آموزشی",
  [EXPLORE_SLUG.LANDING]: "مجموعه آموزشی",
};
